import axiosInstance from "../axios";

export const getEficienciaHistorico = (limite = 50) =>
    axiosInstance
        .get("/amostras/eficiencia-historico", { params: { limite } })
        .then((r) => r.data);
